export class ScholershipOSExport {
    constructor(public data: {
        ContratcorType?: String,
        CompanyName?: String,
        Firstname?: String,
        Lastname?: String,
        JMBG?: String,
        Email?: String,
        TaxID?: String,
        CompanyID?: String,
        Address?: String,
        Settlement?: String,
        PostalCode?: String,
        ContactPhone?: String,
        DeliveryAddress?: String,
        InsureeFirstname?: String,
        InsureeLastname?: String,
        InsureeAddress?: String,
        InsureeDOB?: String,
        InsureeSettlement?: String,
        InsureePostalCode?: String,
        InsureeJMBG?: String,
        InsureeContactPhone1?: String,
        InsureeContactPhone2?: String,
        InsureeOccupation?: String,
        StartTime?: String,
        EndTime?: String,
        Duration?: Number,
        Age?: Number,
        Gender?: String,
        HazardLevel?: Number,
        CigarettesPerDay?: Number,
        PaymentFrequency?: Number,
        Height?: Number,
        Weight?: Number,
        AdditionalInsurance?: Boolean,
        DeathByAccident?: Number,
        InvalidityByAccident?: Number,
        Surgery?: Number,
        DailyFee?: Number,
        MonthlyRent?: Number,
        TreatmanExpenses?: Number,
        IncludeMSO?: Boolean,
        IncludeDNA?: Boolean,
        riderDeath?: Number,
        tbType?: Number,
        riderTB?: Number,
        SelectedPackage?: Number,
        PremiumRate?: Number,
        Offer?: Boolean,
        RedemptionAndCapitalization?: Boolean,
        ProContract?: Boolean,
        Terms?: Boolean,
        AdditionalDocumentation?: Boolean,
        SumInsured?: Number,
        AdditionalPremiumRate?: Number,
        TotalPremiumRate?: Number,
        TotalPremiumRateYearly?: Number,
        PaymentPeriodOut?: Number,
        PaymentPeriodIn?: Number,
        AdditionalSumInsured?: Number,
        AdditionalInsuranceDeathPremiumRate?: Number,
        AdditionalInsuranceDeath?: Boolean,
        GrantTable?: Array<any>
    }) { }
}